const o = "root-design-css", s = "root-font-css";
export {
  o as ROOT_DESIGN_ID,
  s as ROOT_FONT_ID
};
